import React, { useEffect } from 'react'
import Navbar from '../../components/layouts/navbar'
import { connect } from 'react-redux'
import * as profileActions from '../../store/profile'
import * as applicationActions from '../../store/application'
import * as jobActions from '../../store/job'
import BetaSignage from '../../components/layouts/betaSignage'
import {
  BriefcaseIcon,
  DocumentTextIcon,
  OfficeBuildingIcon,
  LightBulbIcon,
  ReceiptTaxIcon,
  NewspaperIcon,
  ChevronRightIcon,
  BadgeCheckIcon,
  ClockIcon,
  UsersIcon,
  BeakerIcon,
} from '@heroicons/react/solid'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { stripeBillingPortal } from '../../store/profile/index'
import { useHistory, useLocation } from 'react-router-dom'
import { getProfile } from '../../store/profile/index'
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const RecruiterDashboard = ({
  profile,
  application,
  jobs,
  getRecruiterApplications,
  getAllRecruiterJobs,
  loading,
}) => {
  useEffect(() => {
    getRecruiterApplications()
    getAllRecruiterJobs()
  }, [getRecruiterApplications, getAllRecruiterJobs])

  const search = useLocation().search
  const dispatch = useDispatch()
  const profileData = useSelector((state) => state.profile)
  const history = useHistory()
  useEffect(() => {
    if (new URLSearchParams(search).get('success')) {
      dispatch(getProfile())
    }
  }, [])

  if (
    !profileData?.profile?.userRef?.subscription &&
    profileData?.profile?.organizationRole === 'admin'
  ) {
    history.push('/subscription')
  }
  const editInfo = async () => {
    await dispatch(
      stripeBillingPortal({
        customerid: profileData?.profile?.userRef?.subscription?.customer_Id,
      }),
    ).then((data) => {
      window.location.href = data.url
    })
  }

  const onApplicantsTitleClick = () => {
    dispatch({ type: 'title', title: 'Search Applicants' })
    dispatch({ type: 'Search Applicants' })
  }

  const actions = [
    {
      icon: BriefcaseIcon,
      name: 'Post a new Job',
      href: '/jobs/new',
      iconForeground: 'text-teal-800',
      iconBackground: 'bg-dash',
      description: 'This is where you will upload your job posting information.',
      disabled: false,
    },
    {
      icon: DocumentTextIcon,
      name: 'View Applications',
      href: '/applications',
      iconForeground: 'text-teal-800',
      iconBackground: 'bg-dash',
      description: 'View applications for all posted positions',
      disabled: false,
    },
    {
      icon: OfficeBuildingIcon,
      name: 'View Company Profile',
      href: `/companyProfile/${
        profileData && profileData?.profile?.organization?._id
      }`,
      iconForeground: 'text-teal-800',
      iconBackground: 'bg-dash',
      description: 'View and manage your company page',
      disabled: false,
    },
    {
      icon: LightBulbIcon,
      displayName: 'Nuleep Labs',
      name:'Home', 
      href: '#',
      iconForeground: 'text-teal-800',
      iconBackground: 'bg-dash',
      description: 'Coming Soon!',
      disabled: true,
    },
    {
      icon: ReceiptTaxIcon,
      name: 'Billing Portal',
      href: 'javascript:void(0)',
      iconForeground: 'text-teal-800',
      iconBackground: 'bg-dash',
      description: 'View and manage your billing information',
      disabled: false,
    },
    {
      icon: NewspaperIcon,
      name: 'View Blog',
      href: '/blogs',
      iconForeground: 'text-teal-800',
      iconBackground: 'bg-dash',
      description: 'View blogs.',
      disabled: false,
    },
  ]
  return (
    <div>

      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-4">
        <main className="pb-8 mt-8">
          {profile?.profile.organizationRole === 'unapproved' ? (
            <p className="mt-24 text-2xl text-center text-gray-500">
              Awaiting Organization Approval
            </p>
          ) : (
            <div className="">
              <h1 className="sr-only">Profile</h1>
              <div
                style={{ display: loading ? 'block' : 'none' }}
                className="border mb-6 py-12 sm:py-6 border-gray-300 rounded-lg"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="80"
                  height="80"
                  viewBox="0 0 24 24"
                  className="m-auto"
                  fill="#0F9488"
                >
                  <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.25 8.891l-1.421-1.409-6.105 6.218-3.078-2.937-1.396 1.436 4.5 4.319 7.5-7.627z" />
                </svg>
              </div>
              {/* Main 3 column grid */}
              <div className="grid items-start grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-8">
                {/* Left column */}
                <div className="grid grid-cols-1 gap-4 lg:col-span-2">
                  {/* Welcome panel */}
                    <section arialabelledby="profile-overview-title-new">
                      <div className="overflow-hidden bg-white rounded-lg shadow ">
                        <div className="p-3 lg:p-6 bg-dash">
                          <div className="lg:flex lg:flex-row justify-center">
                            <div className="flex p-2 pt-4 pr-8 lg:border-r-2 lg:border-gray-300">
                              <div className="lg:flex items-center justify-center w-16 h-16 lg:w-28 lg:h-28 text-3xl bg-blue-100 rounded-full ring-4 ring-dash_icon_color">
                                <p className="p-2 font-bold text-center text-blue-800 font-nunito">
                                  {profile?.profile.firstName.charAt(0)}
                                </p>
                              </div>
                              <div className="ml-4 lg:ml-8 lg:mt-4">
                                <div className="lg:mt-4 text-left sm:mt-0 sm:pt-1 sm:text-left">
                                  <p className="text-sm font-normal text-gray-500">
                                    Welcome,
                                  </p>
                                  <div className="xs:flex items-center justify-center">
                                  <p className="text-xl font-bold text-gray-900">
                                    {profile?.profile.fullName}
                                  </p>
                                  <p className="text-sm xs:ml-2 font-medium text-gray-600">
                                    {profile?.profile.title} of{' '}
                                    {profile?.profile.organization &&
                                      profile?.profile.organization.name}
                                  </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="lg:flex items-center justify-center text-xl lg:mx-3 mt-2 p-2 rounded-lg w-auto h-auto lg:w-32 bg-white"
                              onClick={onApplicantsTitleClick}
                              >
                              <div className="flex lg:flex-col text-center">
                                <div className="text-4xl">{application.recruiterApplications?.length} </div>
                                <div className="m-2">Current Applicants</div>
                              </div>
                            </div>
                            <div className="lg:flex items-center justify-center text-xl lg:mx-3 mt-2 p-2 rounded-lg w-auto h-auto lg:w-32 bg-white"
                              onClick={onApplicantsTitleClick}>
                              <div className="flex lg:flex-col text-center">
                                <div className="text-4xl">{application.recruiterApplications?.length} </div>
                                <div className="m-2">Saved Applicants</div>
                              </div>
                            </div>
                            <div className="lg:flex items-center justify-center text-xl lg:mx-3 mt-2 p-2 rounded-lg w-auto h-auto lg:w-32 bg-white"
                                onClick={onApplicantsTitleClick}>
                              <div className="flex lg:flex-col text-center">
                                <div className="text-4xl">{jobs.recruiterJobs?.length} </div>
                                <div className="m-2">Open Jobs</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                  <section arialabelledby="profile-overview-title" className="hidden">
                    <div className="overflow-hidden bg-white rounded-lg shadow">
                      <h2 className="sr-only" id="profile-overview-title">
                        Profile Overview
                      </h2>
                      <div className="p-6 bg-white">
                        <div className="sm:flex sm:items-center sm:justify-between">
                          <div className="sm:flex sm:justify-center sm:w-full sm:space-x-5">
                            <div className="flex-shrink-0">
                              <div className="flex items-center justify-center w-20 h-20 text-3xl bg-blue-100 rounded-full">
                                <p className="p-2 font-bold text-center text-blue-800 font-nunito">
                                  {profile?.profile.firstName.charAt(0)}
                                </p>
                              </div>
                            </div>

                            <div className="mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left">
                              <p className="text-sm font-medium text-gray-600">
                                Welcome,
                              </p>
                              <p className="text-xl font-bold text-gray-900 sm:text-2xl">
                                {profile?.profile.firstName}
                              </p>
                              <p className="text-sm font-medium text-gray-600">
                                {profile?.profile.title} of{' '}
                                {profile?.profile.organization &&
                                  profile?.profile.organization.name}
                              </p>
                            </div>
                          </div>
                          <div className="flex justify-center mt-5 sm:mt-0">
                            {/* <Link
                                                        to={`/profiles/${profile.profile?._id}`}
                                                        className="flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
                                                    >
                                                        View profile
                                                    </Link> */}
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 border-t border-gray-200 divide-y divide-gray-200 bg-gray-50 sm:grid-cols-2 sm:divide-y-0 sm:divide-x">
                        <div className="px-6 py-5 text-sm font-medium text-center grid-row-3">
                          {/* <span className="text-gray-900">
                            {application.recruiterApplications?.length}
                          </span>{" "}
                          <span className="text-gray-600">
                            Open Application(s)
                          </span> */}

                          <div
                            className="text-gray-600 cursor-pointer"
                            // to={`company/apllication`}
                            onClick={() => {
                              dispatch({type: 'title', title: 'Company Dashboard'})
                              dispatch({type: 'company_dashboard'})
                            }}
                          >
                            {application.recruiterApplications?.length} Open
                            Application(s)
                          </div>
                        </div>
                        <div className="px-6 py-5 text-sm font-medium text-center grid-row-3 cursor-pointer">
                          {/* <span className="text-gray-900">
                            {jobs.recruiterJobs?.length}
                          </span>{" "}
                          <span className="text-gray-600">Job(s) Posted</span> */}
                          <div className="text-gray-600" to={`company/jobs`} onClick={() => {
                            dispatch({type: 'company_dashboard'})
                            dispatch({type: 'title', title: 'Company Dashboard'})
                          }}>
                            {jobs.recruiterJobs?.length} Job(s) Posted
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  {/* Actions panel */}
                  <section aria-labelledby="quick-links-title" className="">
                    <div className="overflow-hidden divide-y divide-gray-200 lg:divide-y-0 md:grid md:grid-cols-3 lg:gap-4">
                      <h2 className="sr-only" id="quick-links-title">
                        Quick links
                      </h2>
                      {actions.map((action, actionIdx) => (
                        <div
                          key={action.name}
                          className={classNames(
                            actionIdx === 0
                              ? 'rounded-tl-lg sm:rounded-tr-none'
                              : '',
                            actionIdx === 1 ? '' : '',
                            actionIdx === actions.length - 2 ? '' : '',
                            actionIdx === actions.length - 1
                              ? 'rounded-br-lg sm:rounded-bl-none'
                              : '',
                            'relative group rounded-lg shadow py-2 m-1 w-auto h-auto bg-white focus-within:ring-2 focus-within:ring-inset focus-within:ring-cyan-500 border',
                          )}
                          onClick={() => {
                            if (actionIdx === 4) {
                              editInfo()
                            }
                          }}
                        >
                          <div className="p-2 lg:m-2 sm:flex h-auto">
                            <div className="flex items-center">
                              <span
                                className={classNames(
                                  action.iconBackground,
                                  action.iconForeground,
                                  'rounded-full inline-flex p-3 ring-4 ring-white ',
                                )}
                              >
                                <action.icon
                                  className="w-8 h-8 lg:w-12 lg:h-12 text-dash_icon_color scale-75 group-hover:text-teal-700 transition-all duration-500 transform group-hover:scale-100"
                                  aria-hidden="true"
                                />
                              </span>
                            </div>
                            <div className="lg:mt-2 ml-2 sm:w-5/6">
                              <h3 className="text-xl font-medium">
                                <div
                                  to={action.href}
                                  className="focus:outline-none cursor-pointer"
                                  onClick={() => {
                                    dispatch({ title: action.name, type: 'title' })
                                    dispatch({ type: action.name, organizationId: profileData?.profile?.organization?._id })
                                  }}
                                >
                                  {/* Extend touch target to entire panel */}
                                  <span
                                    className="absolute inset-0"
                                    aria-hidden="true"
                                  />
                                  {action.displayName ? action.displayName : action.name}
                                </div>
                              </h3>
                              <p className="lg:mt-2 text-sm text-gray-500">
                                {action.description}
                              </p>
                            </div>
                            <div className="lg:hidden md:hidden flex items-center">
                              <ChevronRightIcon aria-hidden="true" className="w-8 h-8"/>
                            </div>
                            {/* <span
                              className="absolute text-gray-300 pointer-events-none top-6 right-6 group-hover:text-gray-400"
                              aria-hidden="true"
                            >
                              <svg
                                className="w-6 h-6"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" />
                              </svg>
                            </span> */}
                            </div>
                        </div>
                      ))}
                    </div>
                  </section>
                </div>

                {/* Right column */}
                <div className="grid grid-cols-1 gap-4">
                  {/* Announcements */}
                  <section aria-labelledby="announcements-title">
                    <div className="overflow-hidden bg-white rounded-lg shadow">
                      <div className="p-6">
                        <h2
                          className="text-base font-medium text-gray-900"
                          id="announcements-title"
                        >
                          Announcements
                        </h2>
                        <p className="my-12 text-center text-gray-300">
                          No new announcements
                        </p>
                        {/* <div className="mt-6">
                                                <a
                                                    href="/"
                                                    className="flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
                                                >
                                                    View all
                                                </a>
                                            </div> */}
                      </div>
                    </div>
                  </section>

                  {/* Recent Hires */}
                  <section aria-labelledby="recent-hires-title">
                    <div className="overflow-hidden bg-white rounded-lg shadow">
                      <div className="p-6">
                        <h2
                          className="text-base font-medium text-gray-900"
                          id="recent-hires-title"
                        >
                          Recent Applications
                        </h2>
                        <div className="flow-root mt-6">
                          <ul className="-my-5 divide-y divide-gray-200">
                            {application.recruiterApplications
                              ?.slice(0, 3)
                              .map((app) => (
                                <li key={app._id} className="py-4">
                                  <div className="flex items-center space-x-4">
                                    <div className="flex items-center justify-center w-10 h-10 text-lg bg-blue-100 rounded-full">
                                      <p className="p-2 font-bold text-center text-blue-800 font-nunito">
                                        {app.profile.firstName[0]}
                                      </p>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <p className="text-sm font-medium text-gray-900 truncate">
                                        {app.profile.firstName}{' '}
                                        {app.profile.lastName}
                                      </p>
                                      <p className="text-sm text-gray-500 truncate">
                                        {app.job.positionTitle}
                                      </p>
                                    </div>
                                    <div>
                                      <Link
                                        to={`applications/${app._id}`}
                                        className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                                      >
                                        View
                                      </Link>
                                    </div>
                                  </div>
                                </li>
                              ))}
                          </ul>
                        </div>
                        <div className="mt-6">
                          <div
                            onClick={() => {
                              dispatch({type: 'title', title: 'Applications'})
                                dispatch({type: 'My Applications'})
                            }}
                            to="/applications"
                            className="flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 cursor-pointer"
                          >
                            View More
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  application: state.application,
  jobs: state.jobs,
})

export default connect(mapStateToProps, {
  ...applicationActions,
  ...profileActions,
  ...jobActions,
})(RecruiterDashboard)
